export const parseJSON = <T = any>(str: string, hideError?: boolean): T | null => {
  let json = null as T;

  try {
    json = JSON.parse(str) as T;
  } catch (error) {
    if (!hideError) {
      console.error('parseJSON', error, str);
    }
  }

  return json;
};
